import { render, staticRenderFns } from "./housesCheck.vue?vue&type=template&id=2aea7608&scoped=true&"
import script from "./housesCheck.vue?vue&type=script&lang=js&"
export * from "./housesCheck.vue?vue&type=script&lang=js&"
import style0 from "./housesCheck.vue?vue&type=style&index=0&id=2aea7608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea7608",
  null
  
)

export default component.exports